import { newClient } from '../axios-client-factory'

// 获取公会长详情
export const getMyGuildAdminDetail = function() {
  return newClient().post('/guild/user/userInfo')
}


export const changeUserNameAjax = function (model) {
  return newClient().post('/guild/user/userName', model)
}

// 绑定手机号
export const bindMobileAjax = function (model) {
  return newClient().post('/guild/user/bindMobile', model)
}
// 换绑手机号
export const changeBindMobileAjax = function (model) {
  return newClient().post('/guild/user/changeBindMobile', model)
}

/**
 * 修改公会名称
 * @param model
 * @returns {*}
 */
export const editGuildName = function (model) {
  return newClient().post('/guild/user/editGuildName', model)
}

/**
 * 修改密码
 * @param model
 * @returns {*}
 */
export const editPwd = function (model) {
  return newClient().post('/guild/user/editPwd', model)
}



// WEBPACK FOOTER //
// ./src/api/guild/personal-center-page.js